module.exports = __webpack_public_path__ + "static/media/dog-doberman.4309b5f0.png";